import React from "react";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import GetAppIcon from "@material-ui/icons/GetApp";
import DescriptionIcon from "@material-ui/icons/Description";
import IlustratorImageUpload from "../../assets/images/ilustrator/img_fileupload.svg";
import LogoXendit from "../../assets/images/btn_Xendit.png";
import { css } from "emotion";
import InvoiceStore from "../../Store/InvoiceStore";
import { formatCurrency } from "../../components/Utils/Currency";
import moment from "moment-timezone";
import Skeleton from "@material-ui/lab/Skeleton";
import ModalUpload from "./parts/ModalUpload";
import DrawerHistory from "./parts/DrawerHistory";
import ReconciliationStore from "../../Store/ReconciliationStore";
import History from "../../History/History";
import InvoiceService from "../../Services/InvoiceService";
import { handleError } from "../../components/Utils/Utils";

const Rekonsiliasi = () => {
  const [invoiceState, invoiceActions] = InvoiceStore();
  const [reconciliationState, reconciliationActions] = ReconciliationStore();
  const [scrollBottom, setScrollBottom] = React.useState(false);
  const [onLoadInvoices, setOnLoadInvoices] = React.useState(false);
  const [downloading, setDownloading] = React.useState(false);
  const [modal, setModal] = React.useState(false);

  const tbodyRef = React.useRef();

  const toggle = () => {
    setModal(!modal);
  };

  const handleReconciliationDone = (id) => {
    toggle();
    History.push(`/rekonsiliasi/result/${id}`);
  };

  const handleClickHistory = (id) => {
    History.push(`/rekonsiliasi/result/${id}`);
  };

  const handleGetList = (refresh) => {
    setOnLoadInvoices(true);
    const params = {
      status: "PAID",
      settled: "false",
      num: 20,
      cursor: refresh ? "" : invoiceState.header["x-cursor"] || "",
    };
    invoiceActions.getInvoiceList(params, refresh).then(() => {
      setOnLoadInvoices(false);
    });
  };

  const handleGetSummary = () => {
    const params = {
      status: "PAID",
      settled: "false",
    };
    invoiceActions.getInvoiceSummary(params)
    .then(() => {
      handleGetList(true)
    });
  };

  const handleDownloadInvoice = () => {
    setDownloading(true);
    const params = {
      status: "PAID",
      settled: "false",
    };
    InvoiceService.downloadInvoice(params)
      .then((response) => {
        setDownloading(false);
        const data = response.data;
        var temp =
          "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
          encodeURIComponent(data.content);
        var download = document.createElement("a");
        download.href = temp;
        download.download = data.file_name;
        document.body.appendChild(download);
        download.click();
        document.body.removeChild(download);
      })
      .catch((error) => {
        setDownloading(false);
        handleError(error);
      });
  };

  const handleGetReconciliationSummary = () => {
    reconciliationActions.getSummaryReconciliation();
  };

  React.useEffect(() => {
    handleGetSummary();
    handleGetReconciliationSummary();
  }, []);

  return (
    <BaseLayout background="gray">
      <div className="row mx-0 w-100">
        <div className="col-12 px-0">
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="font-16 font-bold mb-0 mr-auto">Rekonsiliasi</h3>
            <div className="d-none d-sm-block">
              <button
                type="button"
                className="btn bg-white text-primary mr-2 rounded-8px border-gray-300 font-12 font-bold"
                disabled={downloading}
                onClick={handleDownloadInvoice}
              >
                {!downloading && (
                  <>
                    <GetAppIcon className="mr-2" />
                    Download Laporan
                  </>
                )}

                {downloading && (
                  <>
                    <GetAppIcon className="mr-2" />
                    Proses Download
                  </>
                )}
              </button>
              <DrawerHistory
                anchor="right"
                onClickHistory={(id) => handleClickHistory(id)}
              />
            </div>
          </div>
          <div className="w-100 d-block d-sm-none mt-3">
            <div className="d-flex justify-content-start align-items-center">
              <button
                type="button"
                className="btn bg-white text-primary mr-2 rounded-8px border-gray-300 font-10 font-bold"
                disabled={downloading}
                onClick={handleDownloadInvoice}
              >
                {!downloading && (
                  <>
                    <GetAppIcon className="mr-2" />
                    Download Laporan
                  </>
                )}

                {downloading && (
                  <>
                    <GetAppIcon className="mr-2" />
                    Proses Download
                  </>
                )}
              </button>
              <DrawerHistory
                anchor="right"
                onClickHistory={(id) => handleClickHistory(id)}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row w-100 mx-0 d-flex justify-content-center align-items-start mt-3">
        <div className="col-md-1 col-xs-12 px-0 mb-2 mb-md-0 d-flex flex-column justify-content-start align-items-center">
          <div
            className="w-100 rounded-8px bg-white text-center py-3 px-2 cursor-pointer"
            onClick={() => {
              History.push(`/rekonsiliasi/failed`);
            }}
          >
            <span className="font-10 text-secondary d-block">Result</span>
            <span className="font-13 font-bold text-danger d-flex justify-content-center align-items-center mt-2">
              {!reconciliationState?.isLoadingResult &&
                (reconciliationState?.reconciliationSummary
                  ?.reconciliation_failed ||
                  0)}
              {reconciliationState?.isLoadingResult && <Skeleton width="35%" />}
            </span>
            <span className="font-13 text-danger d-block">No Match</span>
          </div>
        </div>
        <div className="col-md-11 col-xs-12 pl-md-3 pl-0">
          <div className="row">
            <div className="col-md-6 col-xs-12 pr-0 mb-2 mb-md-0">
              <div className="panel panel-body rounded-8px bg-white p-3 h-100">
                <div className="d-flex justify-content-start align-items-center">
                  <div className="mr-auto">
                    <span className="font-10 text-secondary">Data dari</span>
                    <br />
                    <h6 className="font-bold font-13 text-primary">IZY</h6>
                  </div>
                  <div className="mr-3">
                    <span className="font-10 text-secondary">
                      Total transaksi
                    </span>
                    <br />
                    <h6 className="font-bold font-13 text-primary">
                      {invoiceState?.isLoadingResult && <Skeleton />}
                      {!invoiceState?.isLoadingResult &&
                        (invoiceState?.invoiceSummary?.invoice_total || 0)}
                    </h6>
                  </div>
                  <div>
                    <span className="font-10 text-secondary">
                      Total nominal
                    </span>
                    <br />
                    <h6 className="font-bold font-13 text-primary">
                      {invoiceState?.isLoadingResult && <Skeleton />}
                      {!invoiceState?.isLoadingResult &&
                        formatCurrency(
                          process.env.REACT_APP_CURRENCY_CODE,
                          (
                            invoiceState?.invoiceSummary
                              ?.invoice_total_amount || 0
                          ).toString()
                        )}
                    </h6>
                  </div>
                </div>
                <div className="mt-3 table-responsive">
                  <table className="table table-custom-1">
                    <thead>
                      <tr>
                        <th width="10%">No</th>
                        <th width="25%">Tanggal Trx</th>
                        <th width="35%">Nomor Trx</th>
                        <th width="30%">Jumlah</th>
                      </tr>
                    </thead>
                    <tbody ref={tbodyRef}>
                      {invoiceState?.invoices?.length > 0 &&
                        invoiceState.invoices.map((value, index) => {
                          return (
                            <tr key={index}>
                              <td className="text-center" width="10%">
                                {index + 1}
                              </td>
                              <td width="25%">
                                {moment(value.created).format("DD/MM/YYYY")}
                              </td>
                              <td width="35%">{value.external_id}</td>
                              <td width="30%">
                                {formatCurrency(
                                  process.env.REACT_APP_CURRENCY_CODE,
                                  (value.paid_amount || 0).toString()
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      {invoiceState?.isLoading &&
                        Array.from(new Array(5)).map((value, key) => {
                          return (
                            <tr key={key}>
                              <td width="10%">
                                <Skeleton variant="text" animation="wave" />
                              </td>
                              <td width="30%">
                                <Skeleton variant="text" animation="wave" />
                              </td>
                              <td width="30%">
                                <Skeleton variant="text" animation="wave" />
                              </td>
                              <td width="30%">
                                <Skeleton variant="text" animation="wave" />
                              </td>
                            </tr>
                          );
                        })}
                      {!invoiceState?.lastPage &&
                        invoiceState?.invoices?.length > 0 && (
                          <tr>
                            <td colSpan="4" className="text-center">
                              <button
                                type="button"
                                className="btn btn-sm btn-white"
                                onClick={() => handleGetList(false)}
                              >
                                Load more
                              </button>
                            </td>
                          </tr>
                        )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xs-12 pr-0 mb-2 mb-md-0">
              <div className="panel panel-body rounded-8px bg-white p-3 h-100">
                <div className="d-flex flex-column justify-content-start align-items-center">
                  <img
                    src={IlustratorImageUpload}
                    alt="upload file rekonsiliasi"
                    className={css`
                      width: 41.5%;
                      margin-top: 66px;
                    `}
                  />
                  <span className="font-12 font-bold text-primary mt-4">
                    Pilih jenis file upload
                  </span>
                  <div className="d-flex justify-content-center align-items-center mt-3 mb-5">
                    <button
                      type="button"
                      className="btn bg-white"
                      onClick={toggle}
                    >
                      <img src={LogoXendit} alt="xendit" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalUpload
        modal={modal}
        toggle={toggle}
        onReconciliationDone={(id) => handleReconciliationDone(id)}
      />
    </BaseLayout>
  );
};

export default Rekonsiliasi;
